import { TeIcon } from '@topcon/tuicl-react';

type ScoreLevel = 'matched' | 'partial' | 'unmatched';

/**
 * Buckets a 0-100 match-dimension score into the three icons the design draws.
 * Thresholds are the TLM enricher's, shared by both migration scopes.
 */
export function getScoreLevel(score: number): ScoreLevel {
  if (score >= 80) return 'matched';
  if (score >= 60) return 'partial';
  return 'unmatched';
}

interface Props {
  score: number;
}

/** Single per-dimension match indicator used inside the match-score tooltip. */
function ScoreIndicator({ score }: Props) {
  const level = getScoreLevel(score);

  if (level === 'matched') {
    return (
      <TeIcon
        name="check_circle"
        size="m"
        color="icon.success.secondary"
        data-testid="score-matched"
      />
    );
  }

  if (level === 'unmatched') {
    return (
      <TeIcon
        name="cancel"
        size="m"
        color="icon.error.onBackground"
        data-testid="score-unmatched"
      />
    );
  }

  return (
    <TeIcon
      name="circle-minus"
      size="m"
      color="icon.warning.secondary"
      data-testid="score-partial"
    />
  );
}

export default ScoreIndicator;
export type { ScoreLevel };
